import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Placeholder start time — update this once the exact time is confirmed.
const WEBINAR_DATETIME = "2026-08-08T10:00:00+01:00"; // Aug 8, 2026, 10:00 AM WAT
const LIVE_WINDOW_MS = 3 * 60 * 60 * 1000; // show "LIVE NOW" for 3h after start, then hide the bar

const pad = (n) => String(n).padStart(2, "0");

const WebinarCountdownBar = () => {
    const navigate = useNavigate();
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const target = new Date(WEBINAR_DATETIME).getTime();
    const diff = target - now;
    const isLive = diff <= 0 && now - target < LIVE_WINDOW_MS;

    if (diff <= 0 && !isLive) return null;

    const totalSeconds = Math.max(0, Math.floor(diff / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const dateLabel = new Date(WEBINAR_DATETIME).toLocaleString("en-US", {
        timeZone: "Africa/Lagos",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });

    return (
        <button
            onClick={() => navigate("/webinar")}
            className="w-full flex flex-wrap items-center justify-center gap-x-2 gap-y-1 px-3 py-2 text-white bg-gradient-to-r from-[#2148C0] to-[#6C63FF] hover:brightness-110 transition-all text-xs sm:text-sm"
        >
            <span className="font-semibold whitespace-nowrap">
                🎓 Free TeeChaa Webinar
            </span>
            <span className="hidden sm:inline text-white/80 whitespace-nowrap">
                · {dateLabel} WAT
            </span>

            {isLive ? (
                <span className="inline-flex items-center gap-1.5 font-bold bg-white/15 px-2.5 py-1 rounded-full whitespace-nowrap">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse" />
                    LIVE NOW
                </span>
            ) : (
                <span className="font-mono font-bold tabular-nums bg-white/15 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {days > 0 && `${days}d `}{pad(hours)}:{pad(minutes)}:{pad(seconds)}
                </span>
            )}

            <span className="bg-yellow-500 text-gray-900 font-bold px-3 py-1 rounded-full whitespace-nowrap">
                Register Free
            </span>
        </button>
    );
};

export default WebinarCountdownBar;
